import io from "socket.io-client";

//export const socket = io({ path: "/socket.io" });


let socket;

// El token viaja en el handshake para que el backend pueda verificarlo y sacar el
// rol de ahí, en vez de creerle al cliente (si nos fiáramos del handshake, cualquiera
// podría mandar role:'admin' y meterse en la sala admin).
// OJO: el token se guarda con JSON.stringify, así que viene entrecomillado y hay
// que parsearlo, igual que el role en authContext.jsx:53.
const tokenActual = () => {
  const raw = localStorage.getItem("token");
  try {
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    console.warn("Token inválido en storage para el socket");
    return null;
  }
};

export const initiateSocketConnection = () => {
  // Si ya hay una conexión viva se reutiliza. Antes cada página que llamaba a esta
  // función al montar abría su propio socket: con tres páginas montadas eran tres
  // conexiones para el mismo usuario, y cada una repetía los eventos.
  //
  // OJO: si el socket existe pero NO está activo (p. ej. un corte de red), NO se
  // reemplaza por uno nuevo. Antes hacíamos `socket = io(...)` y eso descartaba el
  // objeto viejo: los componentes que ya habían hecho `s.on(...)` sobre él (la
  // burbuja de alertas, que vive en el Layout y no vuelve a correr su effect)
  // quedaban escuchando un socket muerto y dejaban de recibir en tiempo real, sin
  // ningún error visible. Reusamos SIEMPRE el mismo objeto y, si hace falta,
  // reconectamos sobre él para no orfanar listeners.
  if (socket) {
    // El token del handshake tiene que estar SIEMPRE al día.
    //
    // OJO: el handshake se manda UNA sola vez, cuando se abre la conexión. Si
    // el socket se creó antes del login (o con el token de otra sesión), queda
    // con el token viejo: el backend lo toma por ese usuario y no lo reconoce
    // como admin. Por eso, si el token cambió, hay que reconectar para que se
    // mande el handshake nuevo.
    const token = tokenActual();
    const cambioToken = token !== socket.auth?.token;

    if (cambioToken) {
      socket.auth = {
        ...socket.auth,
        username: localStorage.getItem("user"),
        userId: localStorage.getItem("userId"),
        token,
      };
    }

    if (!socket.active) {
      socket.connect();
    } else if (cambioToken && socket.connected) {
      console.log('[socket] Cambió el token: se reconecta para actualizar el handshake');
      socket.disconnect().connect();
    }

    return socket;
  }

  socket = io(
    { path: "/socket.io", 
      auth: {
        username: localStorage.getItem("user"), //await getUsername(),
        userId: localStorage.getItem("userId"),
        token: tokenActual()
        //serverOffset: 0
      }
    }); //, autoConnect: false
  console.log(`Connecting socket desde initiateSocketConnection...`);
  return socket
}

// Cierra la conexión. Se usa al desloguearse para no dejar una sesión vieja
// suscrita a la sala del rol anterior.
export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}

